module.exports = __webpack_public_path__ + "static/media/ticket-export-2.31103d9b.jpg";